export const buildPermissionCode = (interfaceCode, actionCode = 'view') =>
  `${interfaceCode}.${actionCode}`

export const normalizePath = (path) => {
  if (!path) return '/'
  const clean = path.split('?')[0].split('#')[0]
  const normalized = clean.endsWith('/') && clean.length > 1 ? clean.slice(0, -1) : clean
  return normalized || '/'
}

export const ROUTE_INTERFACE_MAP = [
  { prefix: '/gestion-utilisateurs/permissions', code: 'gestion_permissions' },
  { prefix: '/gestion-utilisateurs/api-externe', code: 'api_externe' },
  { prefix: '/gestion-utilisateurs/etat-caisse', code: 'etat_caisse' },
  { prefix: '/gestion-utilisateurs', code: 'utilisateurs' },
  { prefix: '/gestion-hotels/liste-hotels', code: 'liste_hotels' },
  { prefix: '/gestion-hotels/source-production', code: 'source_production' },
  { prefix: '/gestion-hotels/gestion-contrats', code: 'liste_contrats' },
  { prefix: '/gestion-hotels/reservations-hotels', code: 'reservations_hotels' },
  { prefix: '/gestion-hotels/liste-chambres', code: 'liste_chambres' },
  { prefix: '/gestion-hotels/configuration-chambres', code: 'config_chambres' },
  { prefix: '/gestion-hotels/configuration', code: 'configuration_hotels' },
  { prefix: '/gestion-hotels/config-promo/categories', code: 'categories_promo' },
  { prefix: '/gestion-hotels/config-promo/etiquettes', code: 'etiquettes_promo' },
  { prefix: '/gestion-transferts/recherche', code: 'transferts_recherche' },
  { prefix: '/gestion-transferts/reservations', code: 'transferts_reservations' },
  { prefix: '/gestion-transferts/vehicules', code: 'transferts_vehicules' },
  { prefix: '/gestion-transferts/categories-vehicules', code: 'transferts_categories_vehicules' },
  { prefix: '/gestion-transferts/configuration/politiques', code: 'transferts_config_politiques' },
  { prefix: '/gestion-transferts/configuration', code: 'transferts_config_generale' },
  { prefix: '/gestion-transferts/tarification/contrats', code: 'transferts_tarif_contrats' },
  { prefix: '/gestion-transferts/tarification/actions-commerciales', code: 'transferts_tarif_promotions' },
  { prefix: '/gestion-transferts/tarification/extras', code: 'transferts_tarif_extras' },
  { prefix: '/gestion-transferts/regles-metier', code: 'transferts_regles_metier' },
  { prefix: '/gestion-circuits/configuration', code: 'circuits_configuration' },
  { prefix: '/gestion-circuits/rooming-list', code: 'circuits_rooming_list' },
  { prefix: '/gestion-circuits/alerte-stock', code: 'circuits_liste' },
  { prefix: '/gestion-circuits/reservations', code: 'circuits_reservations' },
  { prefix: '/gestion-circuits/moteur', code: 'circuits_moteur' },
  { prefix: '/gestion-circuits/liste', code: 'circuits_liste' },
  { prefix: '/gestion-circuits', code: 'circuits_liste' },
  { prefix: '/cartes-acces/entites', code: 'cartes_entites' },
  { prefix: '/cartes-acces/centres', code: 'cartes_centres' },
  { prefix: '/cartes-acces/recherche', code: 'cartes_recherche' },
  { prefix: '/cartes-acces/reservations', code: 'cartes_reservations' },
  { prefix: '/cartes-acces/partenaires', code: 'cartes_partenaires' },
  { prefix: '/hotel-clients', code: 'hotel_clients' },
  { prefix: '/gestion-client/bon-achat', code: 'bon_achat' },
  { prefix: '/gestion-partenaires/products-access', code: 'products_access' },
  { prefix: '/gestion-partenaires', code: 'gestion_partenaires' },
  { prefix: '/marge-global', code: 'marge_global' },
  { prefix: '/hotel-fournisseurs', code: 'hotel_fournisseurs' },
  { prefix: '/gestion-financiere/export-reservations', code: 'export_reservations' },
  { prefix: '/gestion-financiere', code: 'gestion_financiere' },
  { prefix: '/gestion_modele_economique', code: 'modele_economique' },
  { prefix: '/gestion-vols/aeroports', code: 'gestion_vols' },
  { prefix: '/connectivite/travelgate', code: 'travelgate' },
  { prefix: '/connectivite/octasoft', code: 'octasoft' },
  { prefix: '/connectivite/cyberesa/bookings', code: 'cyberesa_bookings' },
  { prefix: '/connectivite/cyberesa/mapper', code: 'cyberesa_mapper' },
  { prefix: '/connectivite/cyberesa', code: 'cyberesa' },
  { prefix: '/connectivite/trend', code: 'trend_connectivite' },
  { prefix: '/parametres/modeles-export', code: 'modeles_export' },
  { prefix: '/parametres/notifications', code: 'parametres_notifications' },
  { prefix: '/parametres-entreprise', code: 'parametres_entreprise' },
  { prefix: '/notifications/list', code: 'notifications' },
  { prefix: '/notifications', code: 'notifications' },
  { prefix: '/contract-audit-logs', code: 'contract_audit_logs' },
  { prefix: '/audit-logs', code: 'audit_logs' },
  { prefix: '/reservation-process-logs', code: 'reservation_process_logs' },
  { prefix: '/unconfigured-entities', code: 'unconfigured_entities' },
  { prefix: '/support-tickets', code: 'support_tickets' },
  { prefix: '/moteur-reservation', code: 'moteur_reservation' },
  { prefix: '/dashboard', code: 'dashboard' },
  { prefix: '/profile', code: 'profile' },
]

export const matchInterfaceCodeForPath = (path) => {
  const normalized = normalizePath(path)
  const sorted = [...ROUTE_INTERFACE_MAP].sort(
    (a, b) => b.prefix.length - a.prefix.length
  )
  for (const item of sorted) {
    if (normalized === item.prefix || normalized.startsWith(`${item.prefix}/`)) {
      return item.code
    }
  }
  return null
}

export const ACTION_LABELS = {
  view: 'Consulter',
  create: 'Créer',
  update: 'Modifier',
  delete: 'Supprimer',
  export: 'Exporter',
  consult: 'Voir détail',
  view_marge: 'Consulter les marges',
  update_marge: 'Saisir / modifier les marges',
  update_status: 'Changer le statut',
  manage_modele_eco: 'Gérer le modèle économique',
  manage_taux_change: 'Gérer le taux de change',
  delete_marge: 'Supprimer les specs de marge',
}

export const ACTION_CODES = ['view', 'create', 'update', 'delete', 'export', 'consult']

// Catégories mères CRUD
export const CATEGORY_CODES = ['read', 'create', 'update', 'delete', 'other']

export const CATEGORY_LABELS = {
  read: 'Lecture (Read)',
  create: 'Création (Create)',
  update: 'Modification (Update)',
  delete: 'Suppression (Delete)',
  other: 'Autres',
}

const ACTION_CATEGORY = {
  view: 'read',
  consult: 'read',
  export: 'read',
  create: 'create',
  update: 'update',
  delete: 'delete',
}

export const getCategoryForAction = (actionCode) => ACTION_CATEGORY[actionCode] || 'other'

export const getInterfaceActions = (iface) => {
  if (Array.isArray(iface?.actions) && iface.actions.length > 0) {
    return iface.actions
  }
  return ['view']
}

// Regroupe les actions d'une interface sous leurs catégories mères CRUD.
// Utilise iface.actionCategories fourni par le backend si présent, sinon dérive.
export const getInterfaceActionCategories = (iface) => {
  if (Array.isArray(iface?.actionCategories) && iface.actionCategories.length > 0) {
    return iface.actionCategories.map((cat) => ({
      category: cat.category,
      label: cat.label || CATEGORY_LABELS[cat.category] || cat.category,
      actions: (cat.actions || []).map((action) => ({
        code: action.code,
        label: action.label || ACTION_LABELS[action.code] || action.code,
      })),
    }))
  }
  const actions = getInterfaceActions(iface)
  const byCategory = new Map()
  for (const actionCode of actions) {
    const category = getCategoryForAction(actionCode)
    if (!byCategory.has(category)) byCategory.set(category, [])
    byCategory.get(category).push({
      code: actionCode,
      label: ACTION_LABELS[actionCode] || actionCode,
    })
  }
  return CATEGORY_CODES.filter((cat) => byCategory.has(cat)).map((cat) => ({
    category: cat,
    label: CATEGORY_LABELS[cat] || cat,
    actions: byCategory.get(cat),
  }))
}

/** Admin staff from users/login (fullname) — not B2B partner portal users. */
export const isAdminStaffUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return user.fullname !== undefined && user.fullname !== null && user.fullname !== ''
  } catch {
    return false
  }
}

export const isSuperAdminUser = (user) =>
  user?.superAdmin === true ||
  user?.superAdmin === 1 ||
  user?.superAdmin === '1'

export const isCaissierUser = (user) =>
  user?.is_caissier === true || user?.is_caissier === 1 || user?.is_caissier === '1'

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')
  } catch {
    return {}
  }
}

export const canAddEtatCaissePayment = (user = getStoredUser()) =>
  isCaissierUser(user) || isSuperAdminUser(user)


/** Admin back-office (admin + Super Admin), not B2B client/affilié portal */
export const isAdminSpaceUser = (userArg) => {
  let user = userArg
  if (!user) {
    try {
      user = JSON.parse(localStorage.getItem('user') || '{}')
    } catch {
      return false
    }
  }
  if (isSuperAdminUser(user)) return true
  const role = user.role
  if (role === 'admin' || role === 'Super Admin') return true
  return user.fullname !== undefined && user.fullname !== null && user.fullname !== ''
}

export const isPartnerUser = () => {
  try {
    if (isAdminStaffUser()) return false

    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const token = localStorage.getItem('accessToken')
    let jwtInfo = null
    if (token) {
      jwtInfo = JSON.parse(atob(token.split('.')[1]))
    }
    const superAdmin =
      user.superAdmin === true ||
      user.superAdmin === 1 ||
      user.superAdmin === '1' ||
      jwtInfo?.superAdmin === true ||
      jwtInfo?.superAdmin === 1
    if (superAdmin) return false

    const role = user.role || jwtInfo?.role
    const userType = user.userType || jwtInfo?.userType
    return (
      role === 'client' ||
      role === 'partenaire' ||
      role === 'partner' ||
      role === 'affilie' ||
      userType === 'partner'
    )
  } catch {
    return false
  }
}
